export default "__VITE_ASSET__n3CF4ad0__"